








































import wrappers from '@/mixins/wrappers'
import eventTracker from '@/utils/eventTracker'
const requireContext = require.context('@assets/images/onboarding', false, /\.svg$/)
const images = requireContext.keys()
  .reduce(
    (acc, key) => {
      const [svgFile] = key.match(/[^/]+$/g) || []
      return {
        ...acc,
        ...(svgFile ? { [svgFile]: requireContext(key) } : {})
      }
    },
    {} as Record<string, any>
  )
type _oneSlide = {
  imgSrc: string;
  name: string;
}
type _allSlides = _oneSlide[]
export default wrappers.extend({
  name: 'OnboardingSlides',
  data () {
    return {
      slideIndex: 0,
      invertButtonAction: false
    }
  },
  computed: {
    allSlides (): _allSlides {
      const orderedImageKeys = ['1.svg', '2.svg', '3.svg', '4.svg']
        .filter(imgKey => images[imgKey])
      const imageToNameMapping: Record<string, string> = {
        '1.svg': 'one',
        '2.svg': 'two',
        '3.svg': 'three',
        '4.svg': 'four'
      }
      return orderedImageKeys.map(
        imgKey => ({
          imgSrc: images[imgKey],
          name: imageToNameMapping[imgKey]
        })
      )
    },
    slideData (): _oneSlide {
      return this.allSlides[this.slideIndex]
    },
    isLast (): boolean {
      return this.slideIndex === this.allSlides.length - 1
    },
    buttonClass (): string {
      return this.invertButtonAction
        ? 'next next--rotate'
        : this.isLast ? 'last' : 'next'
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDown)
    window.addEventListener('keyup', this.keyUp)
    eventTracker.track('Tutorial Viewed', {
      screen: this.slideIndex + 1
    })
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDown)
    window.removeEventListener('keyup', this.keyUp)
  },
  methods: {
    keyDown (e: KeyboardEvent) {
      if (e.altKey) {
        this.invertButtonAction = true
      }
    },
    keyUp () {
      this.invertButtonAction = false
    },
    dotClicked (event: MouseEvent, index: number) {
      const target = event.currentTarget as HTMLButtonElement
      if (target) {
        target.blur()
      }
      this.slideIndex = index
    },
    async nextSlide (event: MouseEvent) {
      const target = event.currentTarget as HTMLButtonElement
      if (target) {
        target.blur()
      }
      if (event.altKey) {
        if (this.slideIndex > 0) {
          this.slideIndex--
        }
      }
      else {
        if (this.isLast) {
          await this.navigate({ name: 'Onboarding:Agreements' })
        }
        else {
          this.slideIndex++
          eventTracker.track('Tutorial Viewed', {
            screen: this.slideIndex + 1
          })
        }
      }
    }
  }
})
